// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateListFilterBy = (filterString, state) =>
    dispatch => dispatch({
        data: filterString,
        state,
        type: actions.UPDATE_LIST_FILTER_BY
    });

export const updateListSortBy = (sortPath, state) =>
    dispatch => dispatch({
        data: sortPath,
        state,
        type: actions.UPDATE_LIST_SORT_BY
    });

export const updateListSortDirection = (direction, state) =>
    dispatch => dispatch({
        data: direction,
        state,
        type: actions.UPDATE_LIST_SORT_DIRECTION
    });



// WEBPACK FOOTER //
// ./src/product/shared/action-creators/refine-list.js